import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { formatPhoneNumber } from 'src/utils/format-number';

import { useTranslate } from 'src/locales';
import { useVoiceCallAllowed } from 'src/hook/use-voice-call-allowed';

// ----------------------------------------------------------------------

type Props = {
  value: string;
  row: any;
  handlePhoneNumberClick?: (row: any) => void;
};

// ----------------------------------------------------------------------

export function RowCellPhone({ value, row, handlePhoneNumberClick }: Props) {
  const { t } = useTranslate('translation');
  const voiceCallAllowed = useVoiceCallAllowed();
  const formatted = formatPhoneNumber(value);

  if (!voiceCallAllowed) {
    return (
      <Tooltip title={t('VOICE_CALL_NOT_AVAILABLE')} placement="top" enterDelay={400}>
        <Typography
          component="span"
          variant="body2"
          color="text.secondary"
          sx={{ cursor: 'help', textDecoration: 'underline dotted', textUnderlineOffset: 3 }}
        >
          {formatted}
        </Typography>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={t('PHONE_CELL_CLICK_TO_CALL')} placement="top" enterDelay={400}>
      <span style={{ display: 'inline-flex' }}>
        <Link
          component="button"
          type="button"
          onClick={() => handlePhoneNumberClick?.(row)}
          color="inherit"
          sx={{
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            padding: 0,
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              color: 'primary.main',
              transform: 'translateX(4px)',
            },
          }}
        >
          {formatted}
        </Link>
      </span>
    </Tooltip>
  );
}
